import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Expense from '../../entities/expense';
import Matter from '../../entities/matter';
import Invoice from '../../entities/invoice';
export function deleteExpense(expense: Expense, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = expense.id;}
const _work = workingSet();
store.getState().matters.getMappingFor('expenseId', expense.id).filter(matterTemp => matterTemp.status !== 'D').forEach(matterTemp => {
const _matter = ((_work.get('matter:' + matterTemp.id) ?? matterTemp) as Matter).clone();
_matter.status = 'U';
_matter.addedOn = newHRTimestamp();
_matter.addedBy = getCurrentUserId();
_matter.importSource = targetImportSource;
_matter.importId = mergeId;
_matter.expenses = _matter.expenses?.filter(id => id !== expense.id) || [];

_work.set('matter:' + _matter.id, _matter);
store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
});



expense.status = 'D';
expense.addedOn = newHRTimestamp();
expense.addedBy = getCurrentUserId();
expense.importSource = targetImportSource;
expense.importId = mergeId;
store.dispatch(Actions.ExpenseActions.removeExpenseQueue(expense));
}
export function replaceExpense(expense: Expense, replaceWith: Expense, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = expense.id;}
const _work = workingSet();
store.getState().matters.getMappingFor('expenseId', expense.id).filter(matterTemp => matterTemp.status !== 'D').forEach(matterTemp => {
const _matter = ((_work.get('matter:' + matterTemp.id) ?? matterTemp) as Matter).clone();
_matter.status = 'U';
_matter.addedOn = newHRTimestamp();
_matter.addedBy = getCurrentUserId();
_matter.importSource = targetImportSource;
_matter.importId = mergeId;
_matter.expenses = _matter.expenses?.map(id => (id === expense.id) ? replaceWith.id : id) || [];

_work.set('matter:' + _matter.id, _matter);
store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
});



return expense;
}
export function deleteImpactExpense(expense: Expense) {
const impacts: string[] = [];
const state = store.getState();
const matterExpensesImpact = state.matters.getMappingFor('expenseId', expense.id).filter(matter => matter.status !== 'D');
matterExpensesImpact.forEach(() => impacts.push('matters'));
const invoiceExpenseIdsImpact = state.invoices.getMappingFor('expenseIds', expense.id).filter(invoice => invoice.status !== 'D');
invoiceExpenseIdsImpact.forEach(() => impacts.push('invoices'));



return util.countDistinct(impacts);
}
